<div class="row">
  <div class="col-12">
    <h2>{{ newsItem().headline }}</h2>
  </div>
</div>

<div class="row mt--32">
  @if (newsItem().carrier && newsItem().carrier.length > 0) {
    <div class="col-12 col-md-3 border-md-end">
      <myarvato-data-field
        [label]="'pages.transport.tracking-overview.widgets.news-updates.data-fields.carrier' | translate"
        [data]="newsItem().carrier"
      />
    </div>
  }
  @if (newsItem().country && newsItem().country.length > 0) {
    <div class="col-12 mt--16 mt-md--0 col-md-3 border-md-end">
      <myarvato-data-field
        [label]="'pages.transport.tracking-overview.widgets.news-updates.data-fields.country' | translate"
        [data]="newsItem().country"
      />
    </div>
  }

  @if (newsItem().start) {
    <div class="col-12 mt--16 mt-md--0 col-md-3 border-md-end">
      <myarvato-data-field
        [label]="'pages.transport.tracking-overview.widgets.news-updates.data-fields.start' | translate"
        [data]="newsItem().start | dayjs"
      />
    </div>
  }
  @if (newsItem().prospectiveEnd) {
    <div class="col-12 mt--16 mt-md--0 col-md-3">
      <myarvato-data-field
        [label]="'pages.transport.tracking-overview.widgets.news-updates.data-fields.prospectiveEnd' | translate"
        [data]="newsItem().prospectiveEnd | dayjs"
      />
    </div>
  }
</div>

<div class="row mt--32">
  <div class="col-12">
    {{ newsItem().comment }}
  </div>
</div>

@if (newsItem().linkUrl) {
  <div class="row mt--32">
    <div class="col-12">
      <a class="content--link" [href]="newsItem().linkUrl" rel="noopener noreferrer" target="_blank">
        {{
          newsItem().linkDescription ??
            newsItem().linkUrl ??
            ('pages.transport.tracking-overview.widgets.news-updates.data-fields.link' | translate)
        }}<i class="pi pi-arrow-up-right ml--8" aria-hidden="true"></i>
      </a>
    </div>
  </div>
}
